<template>
  <VBtn
    v-bind="$props"
    v-on="$listeners"
  >
    <slot />
  </VBtn>
</template>

<script>
import { VBtn } from 'vuetify/lib';
import { filterProps } from "@/utils/functional-component-utils";

export default {
  name: "WorkButton",
  components: { VBtn },
  props: {
    ...filterProps(VBtn.options.props, ['activeClass']),
    outlined: { type: Boolean, default: false },
    color: { type: String, default: 'primary' },
  },
}
</script>
